<template lang="pug">
  .b-ellipsis-menu(:class="{ light }" v-if="items.length")
    Icon._icon(name="more" @click.native="isOpened = !isOpened" pointer :class="{ vertical, hidden, isOpened }")
    CommonDropdown._dropdown(:items="items" :isOpened="isOpened" @click.native="isOpened = false")
</template>

<script>
import CommonDropdown from '@/components/CommonDropdown.vue';

export default {
  name: 'EllipsisMenu',
  components: { CommonDropdown },
  props: {
    items: Array,
    light: Boolean,
    vertical: Boolean,
    hidden: Boolean,
  },
  data() {
    return {
      isOpened: false,
    };
  },
  methods: {
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.isOpened = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.close);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close);
  },
};
</script>

<style scoped lang="scss">
.ellipsis-menu {
  position: relative;
  fill: var(--color-light-dark);

  &:before {
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
    top:-8px;
    left: -8px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    transition: background-color 0.1s;
  }

  &:not(.light):hover {
    cursor: pointer;

    &:before {
      background-color: var(--color-super-light);
    }
  }

  &__icon {
    display: block;
    width: 24px;
    height: 24px;
    position: relative;
    z-index: 2;

    &.vertical {
      transform: rotate(90deg);
    }

    &.hidden {
      opacity: 0;

      &.isOpened, &:hover {
        opacity: 1;
      }
    }
  }
  &__dropdown {
    top: 30px;
    right: calc(50% + 5px);
    transform: translateX(50%);
    &:before {
      right: 0;
      left: calc(50% + 5px);
      transform: translateX(-50%);
    }
  }

  &.light &__icon {
    fill: #D3EAFF;
  }

  @media(max-width: 1500px) {
    &__dropdown {
      right: 0;
      transform: none;

      &:before {
        display: none;
      }
    }
  }
}
</style>
